import script from "./MainContent.vue?vue&type=script&setup=true&lang=js"
export * from "./MainContent.vue?vue&type=script&setup=true&lang=js"

import "./MainContent.vue?vue&type=style&index=0&id=77ad4278&lang=css"

const __exports__ = script;

export default __exports__